import axios from '../../plugins/axios';

/**
 * Загружает документ автомобиля на сервер.
 *
 * @param {Object} params
 * @param {File} params.file - Файл документа
 * @param {number|string} params.carId - ID автомобиля
 * @param {string} params.name - Название документа
 * @param {number} params.typeId - Тип документа (ID)
 * @returns {Promise<Object>} 
 */
export async function uploadCarDocument({ file, carId, name, typeId }) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('carId', carId);
  formData.append('name', name);
  formData.append('typeId', typeId);
  const response = await axios.post('/crm/cars/uploadDocument', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: true,
  });
  return response.data;
} 